'use strict';

jQuery(document).ready(function ($) {

  'use strict';

  var $nav = $('#nav');
  var $navcollapse = $('.navbar-collapse');
  // Ako je navbar uključen, tj. ako ima dropdown onda nemoj afiksirati jer je bug
  $nav.on('affix.bs.affix', function () {
    if (!$navcollapse.hasClass('collapse')) {
      return false;
    }
  });
  /*	affix.bs.affix => before fixed positioning is applied to an element
  affixed.bs.affix => after fixed positioning is applied to an element
  affix-top.bs.affix => before a top element returns to its original (non-fixed) position
  affixed-top.bs.affix => after a top element returns to its original (non-fixed) position
  affix-bottom.bs.affix => before a bottom element returns to its original (non-fixed) position
  affixed-bottom.bs.affix => after a bottom element returns to its original (non-fixed) position*/

  // Tražilica u navigaciji - testirat jer pisano napamet

  var $navSearchBtn = $('.navbar-search__btn');
  var $navSearchForm = $('#nav-search');
  var $navSearchFormInput = $('#input--search-nav');
  var $navSearchBtnClose = $('#close-btn');

  $('html').on('click', function () {
    $navSearchForm.removeClass('appear');
  });

  $navSearchFormInput.on('click', function (e) {
    e.stopPropagation();
  });

  $navSearchBtn.on('click', function (e) {
    e.stopPropagation();
    $navSearchForm.toggleClass('appear');
    navInputSetFocus();
  });

  // Zatvara tražilicu na mobitelima
  $navSearchBtnClose.on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    $navSearchForm.toggleClass('appear');
  });

  // Hack za focus na input
  function navInputSetFocus() {
    setTimeout(function () {
      $navSearchFormInput.focus();
    }, 50);
  }

  // Galerija 

  var $fancybox = $('a.fancybox');
  if ($fancybox.length) {
    $('a.fancybox').fancybox({
      keyboard: true,
      arrows: true
    });
    // .attr('data-fancybox', 'group') - inače prekorači grupu kod arhive galerija
  }

  // Owl carousel

  var $instagram = $('.owl-instagram');
  if ($instagram.length) {
    $('.owl-instagram').owlCarousel({
      loop: false,
      autoplay: false,
      margin: 0,
      dots: false,
      nav: true,
      navText: ['<i class="mdi mdi-chevron-left" aria-hidden="true"></i>', '<i class="mdi mdi-chevron-right" aria-hidden="true"></i>'],
      responsive: {
        0: {
          items: 3
        },
        768: {
          items: 4,
          autoWidth: true
        },
        992: {
          items: 4
        }
      }
    });
  }

  var $apartman = $('.owl-apartman');
  if ($apartman.length) {
    $('.owl-apartman').owlCarousel({
      loop: false,
      autoplay: false,
      margin: 0,
      dots: false,
      nav: true,
      navText: ['<i class="mdi mdi-chevron-left" aria-hidden="true"></i>', '<i class="mdi mdi-chevron-right" aria-hidden="true"></i>'],
      responsive: {
        0: {
          items: 1
        },
        768: {
          items: 3,
          autoWidth: true
        }
      }
    });
  }

  // Cookie notice settings

  if (Cookies.get('cookie-notice') !== 'Accepted') {
    var $cookieWrapper = $('#bideja-cookie-notice');
    var $cookieBtn = $cookieWrapper.find('#accept-cookie');
    $cookieWrapper.removeClass('bi-remove');
    $cookieBtn.click(function () {
      // Expire je na 5 godina
      Cookies.set('cookie-notice', 'Accepted', { expires: 365 * 5 });
      // Makni fadeanjem
      $cookieWrapper.fadeOut(300, function () {
        $(this).remove();
      });
    });
  }

  // Stranica apartman - komentari paginacija
  var $komentarContent = $('#komentari-content');
  if ($komentarContent.length) {
    $('#komentari__pagination').twbsPagination({
      totalPages: $komentarContent.data('pages-count'),
      visiblePages: 4,
      onPageClick: function onPageClick(event, page) {
        $komentarContent.html($('#reviews-' + page).html());
      }
    });
  }

  // Fotogalerija
  if ($.isFunction('masonry')) {
    $('.grid').masonry({
      itemSelector: '.grid-item',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  }

  // Anchor link offset
  var target = window.location.hash;
  if (target != '' || target != 'NaN') {
    var $target = jQuery(target);
    if ($target.length) {
      var top = $target.offset().top;
      jQuery('html, body').stop().animate({ 'scrollTop': top - 200 }, 300);
    }
  }

  // Animacije
  $('.animate').each(function () {
    var _this = this;
    console.log($(this));
    $(this).addClass('disappear');
    var inview = new Waypoint({
      element: _this,
      handler: function handler(direction) {
        $(this.element).addClass('appeared');
      },
      offset: '90%'
    });
  });
});